import { useState } from "react";
import { Range as ReactRange } from "react-range";
import { translate } from "../../../localization";
import styles from "./Range.module.scss";

interface RangeProps {
  value: number[];
  onChange: (value: number[]) => void;
  min: number;
  max: number;
  step: number;
}

const Range = ({ value, onChange, min, max, step }: RangeProps) => {
  const i18n = translate();
  const [values, setValues] = useState(value);

  return (
    <div className={styles.rangeContainer}>
      <div className={styles.left}>
        <input value={values[0]} className={styles.input} disabled />
        <div>{i18n.browse.to}</div>
        <input value={values[1]} className={styles.input} disabled />
      </div>
      <div className={styles.right}>
        <ReactRange
          step={step}
          min={min}
          max={max}
          values={values}
          onChange={(values) => setValues(values)}
          onFinalChange={onChange}
          renderTrack={({ props, children }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: "3px",
                width: "100%",
                backgroundColor: "#A29C99",
                cursor: "pointer",
              }}
            >
              {children}
            </div>
          )}
          renderMark={({ props, index }) => {
            if (index % 50 !== 0) {
              return null;
            }
            return (
              <div
                {...props}
                key={props.key}
                style={{
                  ...props.style,
                  height: "8px",
                  width: "8px",
                  backgroundColor: "#A29C99",
                  borderRadius: "50%",
                }}
              >
                <span className={styles.markLabel}>{min + index}</span>
              </div>
            );
          }}
          renderThumb={({ props }) => (
            <div
              {...props}
              key={props.key}
              style={{
                ...props.style,
                height: "16px",
                width: "16px",
                backgroundColor: "#453a33",
                borderRadius: "50%",
              }}
            />
          )}
        />
      </div>
    </div>
  );
};

export default Range;
